import Box from '@mui/joy/Box'
import dayjs from 'dayjs'
import { DeleteButton } from './ui/DeleteButton'
import { CAMPAIGN_TYPE_DISPLAY_NAMES } from '../consts'

export const CampaignRow = ({ campaign, onClick, onDelete }) => {
    const handleDelete = (e) => {
        e.stopPropagation()
        onDelete(campaign)
    }

    return (
        <tr onClick={() => onClick(campaign)}>
            <td>
                <b>{campaign.title}</b>
            </td>
            <td>{CAMPAIGN_TYPE_DISPLAY_NAMES[campaign.type]}</td>
            <td>{dayjs(campaign.create_date).format('LLL')}</td>
            <td>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <DeleteButton onClick={handleDelete} />
                </Box>
            </td>
        </tr>
    )
}
